import React from 'react';

const TextQuestionWithIcon = ({text, icon, subtitle}) => {
    return <>
        <div
            style={{display: "flex", alignItems: "center", justifyContent: "left", color: "#144b5e"}}
        >
        {icon} <label style={{fontWeight: "600", marginLeft: "5px", fontSize: "24px"}}>{text}</label>
        </div>
        {subtitle && <p style={{color: "gray", marginLeft: "5px", fontSize: "16px", fontWeight: "500"}}>{subtitle}</p>}
    </>
};

export default TextQuestionWithIcon;